import a9 from './a9';
const init = (bidders) => {
    bidders.forEach(bidder => {
        const bidderName = bidder.name;
        if (bidderName === 'a9') {
            a9.init(bidder.config);
        }
    });
};
const requestBids = (id, network, sizes, bidders, allBidsBackHandler) => {
    const hasBidderMap = new Set();
    const bidsBackHandler = (bidderName) => {
        hasBidderMap.add(bidderName);
        const bidsBack = Object.keys(hasBidderMap)
            .map(bidder => hasBidderMap.has(bidder))
            .filter(Boolean).length;
        if (bidsBack === bidders.length) {
            allBidsBackHandler();
        }
    };
    bidders.forEach(bidder => {
        const bidderName = bidder.name;
        hasBidderMap.delete(bidderName);
        switch (bidderName) {
            case 'a9':
                a9.fetchBids(id, network, sizes, bidsBackHandler);
                break;
            default:
                bidsBackHandler(bidderName);
        }
    });
};
export default {
    init,
    requestBids,
};
//# sourceMappingURL=bidManager.js.map